(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyCustomerSlideController', CompanyCustomerSlideController);

    CompanyCustomerSlideController.$inject = ['$rootScope', '$scope', '$state', 'CompanyCustomer', 'CompanyCustomerSearch', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'CompanyCustomerCustom', '$mdDialog', '$translatePartialLoader', '$timeout', '$mdSidenav'];

    function CompanyCustomerSlideController($rootScope, $scope, $state, CompanyCustomer, CompanyCustomerSearch, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, CompanyCustomerCustom, $mdDialog, $translatePartialLoader, $timeout, $mdSidenav) {

        var vm = this;
        vm.companyCustomer = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.getCompanyCustomerFormDataFunc = getCompanyCustomerFormDataFunc;
        vm.editCompanyCustomerFormDataFunc = editCompanyCustomerFormDataFunc;
        vm.hasAllNecessaryFields = false;
        vm.customerFormData = null;
        vm.columnCount = null;

        vm.closeSlide = closeSlide;
        vm.okSlide = okSlide;
        vm.gotoNewReserve = gotoNewReserve;

        function loadAll() {
            $translatePartialLoader.addPart('companyCustomer');
            $mdSidenav('customerSide').toggle();
        }

        function getCompanyCustomerFormDataFunc(companyCustomFormId, companyCustomFormTitle) {

            CompanyCustomerCustom.getNewCompanyCustomerFormData(companyCustomFormId).query(function (res) {

                vm.customerFormData = res;
                vm.customerFormData.companyCustomFormTitle = companyCustomFormTitle;
                vm.customerFormData.companyCustomer = vm.companyCustomer;
                openEditDataDialog(vm.customerFormData);

            });
        }

        // function editCompanyCustomerFormDataFunc(companyCustomFormId, companyCustomFormTitle, data) {
        function editCompanyCustomerFormDataFunc(companyCustomFormId, companyCustomFormTitle, data) {

            vm.customerFormData = data;
            vm.customerFormData.companyCustomFormTitle = companyCustomFormTitle;
            vm.customerFormData.companyCustomer = vm.companyCustomer;
            openEditDataDialog(vm.customerFormData);
        }

        // function openEditDataDialog(customerFormData) {
        //     vm.columnCount = 4 ;
        //     $mdDialog.show({
        //         locals: {dialogData: customerFormData , columnCount: vm.columnCount},
        //         controller: ComponentIntakeDataDialogController,
        //         templateUrl: 'app/components/eyeson/intake-data-component/component-intake-data-dialog.html',
        //         controllerAs: '$ctrl',
        //         parent: angular.element(document.body),
        //         targetEvent: customerFormData,
        //         clickOutsideToClose: true
        //     })
        //         .then(function (answer) {
        //             $scope.status = 'You said the information was "' + answer + '".';
        //         }, function () {
        //             $scope.status = 'You cancelled the dialog.';
        //         });
        // };

        function save() {
            vm.isSaving = true;

            if (vm.companyCustomer.id !== null) {
                CompanyCustomerCustom.updateCompanyCustomer().save(vm.companyCustomer, onSaveSuccess, onSaveError);
            } else {
                if (vm.companyCustomer.customer !== null) {
                    CompanyCustomerCustom.addNewCustomer().save(vm.companyCustomer, onSaveSuccess, onSaveError);
                }

            }


            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:companyCustomerUpdate', result);

                // $state.go('company-customer.edit', {id: result.id});

                loadAll();
            }

        }

        function okSlide() {
            save();

        }

        function closeSlide() {
            // if($rootScope.SlideInstance)
            // {
            //     $rootScope.SlideInstance.dismiss('cancel');
            // }

        }

        function gotoNewReserve() {

            $state.go('supplierPanel-v2.reserveWithCustomerParameter', {
                customerId: vm.companyCustomer.customerId
            });

        }


    }
})();
